import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { DialogFrameModule } from "src/app/common/components/dialog-frame/dialog-frame.module";
import { PipesModule } from "src/app/common/pipes/pipes.module";

@Component({
  selector: "tpm-simple-text-dialog",
  templateUrl: "simple-text-dialog.component.html",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PipesModule, TranslateModule, DialogFrameModule]
})
export class SimpleTextDialogComponent {
  readonly data = inject<{ heading: string; content: string; params: unknown }>(MAT_DIALOG_DATA);
}
